import React, { useState } from 'react';
import InputField from '../common/InputField';
import Button from '../common/Button';
import PropTypes from 'prop-types';
import Logo from '../common/Logo';
import { Eye, EyeOff } from 'lucide-react'; 

const LoginForm = ({ onSwitchForm, onSubmit, error }) => {
  const [email, setEmail] = useState('');
 const [password, setPassword] = useState('');
 const [showPassword, setShowPassword] = useState(false); 

 const handleSubmit = async (e) => {
   e.preventDefault();
   try {
     await onSubmit({ email, password });
   } catch (error) {
    console.error(error);
   }
 };

 const togglePasswordVisibility = () => {
   setShowPassword(!showPassword);
 };

 return (
   <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg w-full max-w-md">
     <Logo />
     <h2 className="text-2xl font-bold mb-6 text-center">Accedi al tuo account</h2>

     {error && (
       <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-md">
         {error}
       </div>
     )}

     <InputField
       type="email"
       placeholder="Inserisci Email"
       className="mb-4 w-full border border-orange-300 rounded-md p-2 focus:outline-none"
       value={email}
       onChange={(e) => setEmail(e.target.value)}
       maxLength={50}
     />

     <div className="relative mb-2">
       <InputField
         type={showPassword ? "text" : "password"}
         placeholder="********"
         className="w-full border border-orange-300 rounded-md p-2 pr-10 focus:outline-none"
         value={password}
         onChange={(e) => setPassword(e.target.value)}
       />
       <button
         type="button"
         className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
         onClick={togglePasswordVisibility}
       >
         {showPassword ? (
           <EyeOff size={20} />
         ) : (
           <Eye size={20} />
         )}
       </button>
     </div>

     <button
       type="button"
       onClick={() => onSwitchForm('recovery')}
       className="text-orange-500 hover:underline block mb-6 text-sm"
     >
       Hai dimenticato la password?
     </button>

     <Button
       type="submit"
       text="Accedi"
       className="w-full bg-orange-500 text-white py-3 rounded-md hover:bg-orange-600 mb-6"
     />

     <div className="text-center">
       <span className="text-gray-600">Non hai un account? </span>
       <button
         type="button"
         onClick={() => onSwitchForm('register')}
         className="text-orange-500 hover:underline"
       >
         Inizia da qui
       </button>
     </div>
   </form>
 );
};

LoginForm.propTypes = {
 onSwitchForm: PropTypes.func.isRequired,
 onSubmit: PropTypes.func.isRequired,
 error: PropTypes.string,
 onFieldChange: PropTypes.func
};

export default LoginForm;